import React from 'react';
import { NotificationEntity, useNotificationsFeed } from '@src/core/features';
import NotificationsMenu from './notifications-menu';
import NotificationsModal from './notifications-modal';
import { useBadgeCount } from './useBadgeCount';
import { useNotificationNavigation } from './useNotificationNavigation';

const Notifications: React.FC = () => {
  const [hasOpened, setHasOpened] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  const { notifications, unreadCount, isLoading, markRead, markAllAsRead } = useNotificationsFeed({
    listEnabled: hasOpened,
  });

  const { badgeCount, acknowledge } = useBadgeCount(unreadCount);
  const navigateFromNotification = useNotificationNavigation();

  const handleItemClick = (notification: NotificationEntity) => {
    markRead(notification.id);
    return navigateFromNotification(notification);
  };

  const acknowledgeBadge = () => {
    setHasOpened(true);
    acknowledge();
  };

  const openModal = () => {
    acknowledgeBadge();
    setModalOpen(true);
  };

  return (
    <>
      <NotificationsMenu
        notifications={notifications}
        badgeCount={badgeCount}
        isLoading={isLoading}
        onOpen={acknowledgeBadge}
        onViewAll={openModal}
        onMarkAllAsRead={markAllAsRead}
        onItemClick={handleItemClick} />
      <NotificationsModal
        open={modalOpen}
        notifications={notifications}
        isLoading={isLoading}
        onClose={() => setModalOpen(false)}
        onItemClick={handleItemClick}
        onMarkAllAsRead={markAllAsRead} />
    </>
  );
};

export default Notifications;
